
import { useEffect, useState } from 'react';
import styles from '../style.module.scss';
import moment from 'moment';
import ReactQuill from 'react-quill'; // ES6
import 'react-quill/dist/quill.snow.css'; // ES6
import Loader from 'components/miscellaneous/Loader/Loader';
import api from 'helpers/api';

const EditChangeLog = ({ log }) => {
    const [ title, setTitle ] = useState(log.title);
    const [ content, setContent ] = useState(log.content);
    const [ createdAt, setCreatedAt ] = useState(moment(log.created_at).format('YYYY-MM-DD'));
    const [ published, setPublished ] = useState(log.published ? 1 : 0);
    const [ isLoading, setIsLoading ] = useState(false);

    const submit = async () => {
        setIsLoading(true);
        try {
            const res = await api.patch(`/changelog/${log.id}`, {
                title,
                content,
                published,
                created_at: createdAt
            });

        } catch (e) {

        } finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        if (log === null) {
            setTitle('');
            setContent('');
            setPublished(false);
            setIsLoading(false)
        }
    }, [ log ])

    return (
        <>
            { isLoading && <div className={ styles.loader }>
                <Loader color="#333" />
            </div> }
            <div className={[styles.logCard, styles.logCardFull].join(' ')} style={ { flexDirection: 'column', display: 'flex', gap: '20px' } }>
                <div className='d-flex w-100' style={ { gap: '15px' } }>
                    <div style={ { flexDirection: 'column', display: 'flex', width: '100%' } }>
                        <label>Title</label>
                        <input type="text" className='alma-input' onChange={ (e) => {
                            setTitle(e.target.value)
                        } } defaultValue={ title } />
                    </div>
                    <div style={ { flexDirection: 'column', display: 'flex', minWidth: '150px', marginLeft: 'auto' } }>
                        <label>Create Date</label>
                        <input type="date" className='alma-input' onChange={ (e) => {
                            setCreatedAt(e.target.value)
                        } } defaultValue={ createdAt } />
                    </div>
                    <div style={ { flexDirection: 'column', display: 'flex', minWidth: '150px', marginLeft: 'auto' } }>
                        <label>Published</label>
                        <select className='alma-input' onChange={ (e) => {
                            setPublished(e.target.value === '1' ? 1 : 0)
                        } } defaultValue={ published }>
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                </div>

                <div style={ { flexDirection: 'column', display: 'flex' } }>
                    <div className={ styles.logContent } >
                        <ReactQuill modules={ {
                            toolbar: [
                                [ { 'header': [ 1, 2, false ] } ],
                                [ 'bold', 'italic', 'underline', 'strike', 'blockquote' ],
                                [ { 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' } ],
                                [ 'link', 'image' ],
                                [ 'clean' ]
                            ],
                        } } formats={ [
                            'header', 'font', 'size',
                            'bold', 'italic', 'underline', 'strike', 'blockquote',
                            'list', 'bullet', 'indent',
                            'link', 'image', 'color',
                        ] } value={ content }
                            onChange={ (value) => {
                                setContent(value)
                            } } />
                    </div>
                </div>
            </div>
            <div className='d-flex'>
                <button onClick={ (e) => {
                    submit()
                } } className='alma-button' style={ { marginLeft: 'auto', minWidth: '150px' } }>Save</button>
            </div>
        </>
    )
}

export default EditChangeLog;